import { render } from "./ForgotPassword.vue?vue&type=template&id=5afb2e46"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render

export default script